module.exports = __webpack_public_path__ + "assets/align-right.3624d4b4.svg";